import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const selectCurrentImage = (state: ReduxApplicationState) =>
  state.productImagesCarousel.currentImage;
